export default "__VITE_ASSET__I0_e8Pkf__"